import { HighlightOff } from "@mui/icons-material";
import { StyledCloseButton } from "./styled";
import { IChatCloseButtonProps } from "./types";

const CloseButton = (props: IChatCloseButtonProps)=>{
    return (
        <StyledCloseButton onClick={props.onClick}>
            <HighlightOff/>
        </StyledCloseButton>
    )
}

export {CloseButton}